/**
 * AssessLayout — a chromeless shell for the department-assessment screen.
 *
 * Deliberately NOT AppContainer: department assessors get a focused, menu-free
 * view (the client asked for this — external testers were navigating away to
 * other URS via the left nav and wanted "more restrictions / a clearer UI").
 *
 * It keeps the two guards that AppContainer provides and the assess flow relies
 * on, and nothing else:
 *   - <Authenticate>       token guard + login/forbidden redirects (+ the app
 *                          dialog dispatcher it mounts).
 *   - <CheckModuleAccess>  loads the user profile (AssessmentPanel reads the
 *                          logged user to gate edit/delete of own comments) and
 *                          gates access to the module.
 *
 * Dropped vs AppContainer: the left Nav menu and the entire top AppBar (title,
 * module/structure switcher, session timer, tasks, notifications, background
 * processes, logged-user card). The screen supplies its own header and Back bar.
 */

import { ReactNode } from "react";
import { Box } from "@mui/material";
import { Authenticate } from "../../user/Authenticate";
import { AnyModule, ModuleCode } from "../../modules/moduleSlice";
import { CheckModuleAccess } from "../../modules/ModuleAccessible";

type Props = {
    module: ModuleCode | AnyModule;
    children: ReactNode;
};

export const AssessLayout = ({ module, children }: Props) => (
    <Authenticate>
        <CheckModuleAccess code={module}>
            <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
                {children}
            </Box>
        </CheckModuleAccess>
    </Authenticate>
);

export default AssessLayout;
